module.exports = __webpack_public_path__ + "static/media/Finnovex-SA-2025.b2c36814.png";